<template>
    <div class="landing">
        <div class="top-content">
            <logo-anim></logo-anim>
            <h1>Speel Lotto Hoger/Lager en <br/><strong>maak kans op de hoofdprijs van&nbsp;€&nbsp;4.500,-!</strong></h1>

            <!-- h1>Deze actie is afgelopen. <br/>Houd onze <a href="https://www.facebook.com/Lotto/" target="_blank">Facebook pagina</a> in de gaten voor nieuwe acties en spelletjes.</h1 -->
            <button class="button red" @click="toGame">Start</button>
            <button class="button clean" @click="toExplanation">Uitleg</button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import { TimelineMax, screenfull } from '@/vendor';
    import LogoAnim from '@/app/components/LogoAnim';
    import LottoBall from '@/app/components/Ball';

    export default {
        components: {
            'logo-anim': LogoAnim,
            'v-ball': LottoBall
        },

        mounted()
        {
        },

        methods: {
            toGame()
            {
                if( screenfull.enabled && ( this.$helpers.browserCheck().isMobile || window.navigator.userAgent.indexOf( 'Ubuntu Chromium' ) > -1 ) )
                {
                    screenfull.request();
                }

                this.$router.push( '/game' );
            },

            toExplanation()
            {
                if( screenfull.enabled && this.$helpers.browserCheck().isMobile )
                {
                    screenfull.request();
                }
                this.$router.push( '/uitleg' );
            },

            getAnimateIn()
            {
                let tl = new TimelineMax();

                tl.from( 'h1', 0.3, { y: '20', opacity: 0 });
                tl.staggerFrom( '.button', 0.3, { opacity: 0 }, 0.2 );

                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();

                tl.to( this.$el, 0.3, { opacity: 0 });

                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Landing.vue